/* eslint-disable import/prefer-default-export */
export const ids = {
    english: 1,
    appVersion: window.environment.REACT_APP_BUILD_ID
}

export const defaultId = ids.english;
